/* eslint-disable no-console,import/no-unresolved */
import Router from 'vue-router';
import Login from '@/components/pages/login/Login';
import Order from '@/components/pages/order/Order';
import Buildings from '@/components/pages/buildings/Buildings';
import Building from '@/components/pages/buildings/Building';
import Field from '@/components/pages/fields/Field';
import Suppliers from '@/components/pages/suppliers/Suppliers';
import SupplierForm from '@/components/pages/suppliers/SupplierForm';
import Users from '@/components/pages/users/Users';
import UserForm from '@/components/pages/users/UserForm';
import Wording from '@/components/pages/wording/Wording';
import Settings from '@/components/pages/settings/Settings';
import NotFound from '@/components/pages/404/NotFound';
import middleware from '../util/middleware';

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: middleware.disabledIfIsAuthenticated,
        },
        {
            path: '/',
            name: 'home',
            beforeEnter: middleware.startPage,
        },
        {
            path: '/orders',
            name: 'orders',
            component: Order,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/buildings',
            name: 'buildings',
            component: Buildings,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/wording',
            name: 'wording',
            component: Wording,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/buildings/:buildingId',
            name: 'building',
            component: Building,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/new-building',
            name: 'new-building',
            component: Building,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/buildings/:buildingId/sectors/:fieldId',
            name: 'sector',
            component: Field,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/suppliers',
            name: 'suppliers',
            component: Suppliers,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/supplier',
            name: 'supplier',
            component: SupplierForm,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/supplier-create',
            name: 'supplier-create',
            component: SupplierForm,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/supplier-update/:supplierId',
            name: 'supplier-update',
            component: SupplierForm,
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/users/:userId',
            name: 'user',
            component: UserForm,
            beforeEnter: middleware.isUserGranted,
        },
        {
            path: '/404',
            name: 'not-found',
            component: NotFound,
        },
        {
            path: '*',
            redirect: '/404',
        },
    ],
});

router.beforeEach(middleware.redirectIfNotAuthenticated);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js